import { Typography } from '@mui/material'
import React from 'react'

/**
* @author
* @function EmptyState
**/

export const EmptyState = (props:any) => {
  const { heading, icon, title, description } = props;
  return (
    <div className='MO_emptyState'>
      <div className='heading'><Typography variant="h6">{heading}</Typography></div>
      <div className="content">
        <div>{icon}
        </div>
        <div className='title'>{title}</div>
        <div className='description'>{description}</div>
        {
          props?.hasButton && props?.button
        }
      </div>
    </div>
  )

}